import React from 'react'
import PropTypes from 'prop-types'
import { MMessageBoard } from '../M_MessageBoard'
import { ArrowDownward, Clear, CloseRounded, Done } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { MButton } from '../M_Button'

export function TableMessageBoards({ openConfirmDelete, handleCloseConfirmDelete,
    entityName, postDelete, openAudit, closeAudit, sortAuditData, auditActionColor,
    auditData }) {
    const { t } = useTranslation()
    const breakAuditWidth = useMediaQuery('(min-width:800px)')
    const breakAuditWidth2 = useMediaQuery('(min-width:500px)')
    function messageBoardWidth() { return !breakAuditWidth2 && '100vw' || 'auto' }

    function messageBoardDelete() {
        return (
            <MMessageBoard
                warning
                open={openConfirmDelete}
                onClose={handleCloseConfirmDelete}
                title={<b>{`${t("Delete")} ${t(entityName)}`}</b>}
                body={
                    <span>
                        {t("TitleConfirmDelete")} ?
                    </span>
                }
                footer={
                    <span style={{ display: 'flex' }}>
                        <MButton
                            icon={<Clear style={{ color: 'var(--color-white)' }} />}
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={handleCloseConfirmDelete}
                        />
                        <MButton
                            icon={<Done style={{ color: 'var(--color-white)' }} />}
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={postDelete}
                        />
                    </span>
                }
            />)
    }

    function messageBoardAudit() {
        return <MMessageBoard
            open={openAudit}
            onClose={closeAudit}
            minWidth={breakAuditWidth2 && '80vw' || '99vw'}
            maxWidth={messageBoardWidth()}
            top={!breakAuditWidth && breakAuditWidth2 && '0'}
            left={!breakAuditWidth && breakAuditWidth2 && '0'}
            body={

                <div style={{ height: '70vh', overflow: 'auto', width: '100%', }}>
                    <div style={{ width: '100%', height: '60vh', }}>
                        <h1 style={{ display: 'flex', justifyContent: 'center' }}>{entityName} Audit</h1>
                        {sortAuditData(auditData)?.map((obj, index) => (
                            <Accordion
                                sx={{
                                    border: '1px solid var(--color-black)',
                                    borderRadius: '10px !important',
                                    marginBottom: '20px',
                                    scrollbarWidth: '0px'
                                }}
                                key={obj?.Action + index}
                            >
                                <AccordionSummary
                                    expandIcon={<ArrowDownward />}
                                >
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div style={{ display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%', alignItems: 'center', width: '100%', marginBottom: '10px' }}>
                                            <div style={{ display: 'flex' }}>
                                                <div style={{ fontSize: '12px', marginRight: '10px', alignItems: 'center' }}>
                                                    {t("Action")}:
                                                </div>
                                                <div style={{ color: auditActionColor(obj), fontWeight: 'bolder' }}>
                                                    {obj?.Action}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                    {t("CreatedByEmail")}:
                                                </div>
                                                <div style={{
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'wrap'
                                                }}>
                                                    {obj?.CreatedByEmail}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                    {t("On")}:
                                                </div>
                                                <div >
                                                    {obj?.CreationDate?.replace('T', ' ')?.split('.')[0]}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </AccordionSummary>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div style={{
                                        width: '80%',
                                        borderBottom: `2px solid var(--color-black)`,
                                        marginBottom: '10px',
                                    }}></div>
                                </div>
                                {obj.AuditFields.map((objField, indexFields) => (
                                    <AccordionDetails
                                        key={objField.Field + indexFields}
                                        sx={{
                                            backgroundColor: indexFields % 2 && 'var(--color-grey-light)',
                                            borderBottomLeftRadius: indexFields + 1 === obj?.AuditFields?.length && '10px',
                                            borderBottomRightRadius: indexFields + 1 === obj?.AuditFields?.length && '10px'
                                        }}
                                    >
                                        <div style={{ color: 'var(--color-black)', display: 'grid', gridTemplateColumns: !breakAuditWidth ? 'auto' : '33% 33% 33%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                    {t("Field")}:
                                                </div>
                                                <div style={{
                                                    userSelect: 'all',
                                                    fontWeight: 'bold',
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'wrap',
                                                    wordBreak: 'break-all'
                                                }}>
                                                    {objField?.Field}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                    {t("OldValue")}:
                                                </div>
                                                <div style={{
                                                    userSelect: 'all',
                                                    fontWeight: 'bold',
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'wrap',
                                                    wordBreak: 'break-all'
                                                }}>
                                                    {objField?.OldValue || 'null'}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ fontSize: '12px', marginRight: '10px' }}>
                                                    {t("NewValue")}:
                                                </div>
                                                <div style={{
                                                    userSelect: 'all',
                                                    fontWeight: 'bold',
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'wrap',
                                                    wordBreak: 'break-all'
                                                }}>
                                                    {objField?.NewValue || 'null'}
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                ))}
                            </Accordion>
                        ))
                        }
                    </div>
                    <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                        <MButton
                            none
                            icon={<CloseRounded style={{ color: 'var(--color-red)', scale: '1.5' }} color='var(--color-red)' />}
                            onClick={closeAudit}
                        />
                    </div>
                </div >

            }
        />
    }

    return (
        <div>
            {messageBoardDelete()}
            {messageBoardAudit()}
        </div>
    )
}

TableMessageBoards.propTypes = {
    openConfirmDelete: PropTypes.bool,
    handleCloseConfirmDelete: PropTypes.func,
    entityName: PropTypes.string,
    postDelete: PropTypes.func,
    openAudit: PropTypes.bool,
    closeAudit: PropTypes.func,
    sortAuditData: PropTypes.func,
    auditActionColor: PropTypes.func,
    auditData: PropTypes.array
}


